import React from 'react'

import { AuthParam } from 'types/GlobalSource'

import Alert from 'components_new/atoms/Alert'
import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import TextField from 'components_new/atoms/TextField'

export type TAuthValidation = {
  error: boolean
  success: boolean
  validating: boolean
}

export const INITIAL_AUTH_VALIDATION: TAuthValidation = {
  error: false,
  success: false,
  validating: false
}

interface AuthStepProps {
  authParams: AuthParam[]
  onChange: (values: Record<string, string>) => void
  onValidate: () => void
  validation: TAuthValidation
  values: Record<string, string>
}

const AuthStep = (props: AuthStepProps) => {
  const { authParams, onChange, onValidate, validation, values } = props

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {authParams
        // The database engine comes from the picked card, not from the user.
        .filter((param) => param.attributes.field !== 'database_type')
        .map((param) => (
          <TextField
            key={param.id}
            label={
              param.attributes.optional
                ? `${param.attributes.field} (valfritt)`
                : param.attributes.field
            }
            onChange={(event) =>
              onChange({
                ...values,
                [param.attributes.field]: event.target.value
              })
            }
            value={values[param.attributes.field] ?? ''}
          />
        ))}

      <Box>
        <Button loading={validation.validating} onClick={onValidate}>
          Validera autentisering
        </Button>
      </Box>

      {validation.error || validation.success ? (
        <Alert severity={validation.error ? 'error' : 'success'}>
          {validation.error
            ? 'Autentisering kunde ej valideras'
            : 'Autentisering validerad'}
        </Alert>
      ) : null}
    </Box>
  )
}

export default AuthStep
